<template>
  <div>
    <span v-if="selectedFiles.length === 0" class="text-muted">
      {{ $t('No files selected.') }}
    </span>

    <div v-for="file of selectedFiles" :key="file.localId" class="clip-text nowrap p-b-5">
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <file-icon :icon="file.icon" size="sm" />
      {{ file.name }}
      <input :value="file.localId" :name="inputName" type="hidden" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputName: { type: String, default: 'uploadfiles[]' },
    selectedFiles: { type: Array, default: () => [] },
  },
  data() {
    return {
      // selectedFiles: [],
    }
  },
  methods: {
    addFiles(fileArray) {
      // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
      this.selectedFiles = fileArray
    },
  },
}
</script>

<style scoped lang="scss"></style>
